export default "__VITE_ASSET__Dx$4Wc0u__"